import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'create-team-dialog',
    styleUrls: ['./create-team-dialog.component.css'],
    templateUrl: 'create-team-dialog.component.html',
    standalone: false
})
export class CreateTeamDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<CreateTeamDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { teamName: string }
  ) { }

  saveTeam(): void {
    this.dialogRef.close(this.data.teamName);
  }

  close(confirmed: boolean): void {
    this.dialogRef.close(confirmed);
  }
}